
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexmCNKYJhNEvcS6gePVGyT5ktHXIUJaJEaCL4QIyAZLrsMeta } from "/home/runner/work/sats-website/sats-website/pages/index.vue?macro=true";
import { default as subscribeOsJyRH6ZLy5ErtsDUlrWL4s497TmxM5MNlSAnQzLHMIMeta } from "/home/runner/work/sats-website/sats-website/pages/subscribe.vue?macro=true";
import { default as contact_45ussyYsFGfrL09iyATT3VK3NQhf1PqGPU7kNiHTl_Y4iRAMeta } from "/home/runner/work/sats-website/sats-website/pages/contact-us.vue?macro=true";
import { default as indexT3f_T_45Zlcik1Pl4IVZCoxH3ezjOa00ephQeeqsw247QMeta } from "/home/runner/work/sats-website/sats-website/pages/[page]/index.vue?macro=true";
import { default as _91_46_46_46slug_93mSCrzPMD2f8ZnWfDPJMRC3jGsxwz7NYdzPe30MM6pMAMeta } from "/home/runner/work/sats-website/sats-website/pages/[page]/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/sats-website/sats-website/pages/index.vue")
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("/home/runner/work/sats-website/sats-website/pages/subscribe.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/home/runner/work/sats-website/sats-website/pages/contact-us.vue")
  },
  {
    name: "page",
    path: "/:page()",
    component: () => import("/home/runner/work/sats-website/sats-website/pages/[page]/index.vue")
  },
  {
    name: "page-slug",
    path: "/:page()/:slug(.*)*",
    component: () => import("/home/runner/work/sats-website/sats-website/pages/[page]/[...slug].vue")
  }
]